<template>
    <div>
        <div class="seachHeader ">
            <Navigation :route="navigationRoute"></Navigation>
            <el-input placeholder="关键字搜索" v-model="query.keyword" class="input-with-select" size="mini" clearable>
                <i class="el-icon-search el-input__icon" slot="prefix">
                </i>
                <el-button slot="append" type="danger" size="mini" @click="getList(1)">搜索</el-button>
            </el-input>
        </div>
        <div>
            <div class="paper-item"
                :class="{ 'paper-item-df': e.finishedQuestionCount }"
                v-for="(e, i) in tableData.records" :key="i">
                <div class="paper-item-left">
                    <div class="paper-item-title overS">
                        {{ e.name || '' }}
                    </div>
                    <div class="overS">
                        说明： {{ e.remark || '' }}
                    </div>
                    <!-- <div class="paper-item-left-b">
                        <div>时间：{{ e.papers[0].startTime || '' }}-{{ e.papers[0].endTime || '' }}</div>
                    </div> -->
                    <div class="paper-item-left-b ">
                        <div>进度：<span class="cRed">{{ e.finishedQuestionCount || 0 }}/{{ e.totalQuestionCount || 0 }}</span></div>
                        <div>最近练习时间：<span class="cRed">{{ e.latestAnswerTime  }}</span></div>
                    </div>
                    
                </div>
                <div class="paper-item-right">
                    <el-button type="warning" size="mini" v-if="!e.finishedQuestionCount" @click="start(e)">开始练习</el-button>
                    <el-button type="warning" size="mini" v-if="e.finishedQuestionCount"
                        @click="start(e)">继续练习</el-button>
                    <!-- <div @click="view(e)" v-if="e.finishedQuestionCount" class="score">
                        进度：{{ e.finishedQuestionCount || 0 }}
                        /
                        {{ e.totalQuestionCount || 0 }}
                    </div> -->
                </div>
            </div>
        </div>
        <el-pagination @current-change="handleCurrentChange" background :current-page.sync="query.current"
            :page-size="10" layout="prev, pager, next, jumper" :total="tableData.total">
        </el-pagination>
    </div>
</template>

<script>
import Navigation from "@/components/Navigation.vue";
import { myDbTests } from "@/api/myTest.js";
import { mapState, mapMutations } from "vuex";
export default {
    name: "",
    components: {
        Navigation
    },
    data() {
        return {
            navigationRoute: [
                { name: '我的测试' },
                { name: '个人自测' },
            ],
            query: {
                current: 1,
                size: 10,
                keyword:''
            },
            tableData: { //表格数据
                total: 0,
                records: []
            }
        };
    },
    created() {
        this.getList()
    },
    computed: {

    },
    methods: {
        handleCurrentChange(val) {
            this.query.current = val
            this.getList()
        },
        getList(pageNumber, pageSize) {
            // this.tableData = {
            //     "size": 10,
            //     "total": 100,
            //     "current": 1,
            //     "records": [
            //         {
            //             "id": "1",
            //             "dbPracticeId": "1",//题库练习id
            //             "name": "武汉理工大学2029年第7期入党积极分子培训班",
            //             "remark": "说明",
            //             "finishedQuestionCount": 0,//已做题量
            //             "totalQuestionCount": 100,//总题量
            //         }
            //     ]
            // }
            this.query.current = pageNumber || this.query.current
            this.query.size = pageSize || this.query.size
            myDbTests(this.query).then(res => {
            this.tableData = res
            })
        },
        start(e) {
            if(!e.totalQuestionCount){
                this.$message({
                  message: '该题库暂无试题！',
                  type: 'error'
                })
                return 
            }
            this.$router.push({
                path: '/myTest/myPaperList/doQues',
                query: {
                    id: e.id,
                    name:e.name,
                    jd:e.finishedQuestionCount || 0
                }
            })
        },
        view(e) {
            this.$router.push({
                path: '/myTest/myPaperList/myPaperView',
                query: {
                    id: e.id
                }
            })
        }
    },
};
</script>
<style lang="scss" scoped>
.paper-item {
    margin-top: 20px;
    background: #FDF2F1;
    border-radius: 5px 5px 5px 5px;
    padding: 10px 20px;
    font-weight: 400;
    font-size: 14px;
    color: #767676;
    display: flex;
    align-items: center;

    .paper-item-title {
        font-weight: 500;
        font-size: 16px;
        color: #1A1A1A;
    }

    .paper-item-left {
        flex: 1;

        &>div {
            margin: 10px 0;
        }

        .paper-item-left-b {
            display: flex;

            &>div {
                margin-right: 10px;
            }
        }
    }

    .paper-item-right {
        width: 100px;
    }

    .score {
        color: #E1311A;
        font-weight: 400;
        font-size: 24px;
        line-height: 24px;
        text-align: right;
        cursor: pointer;
    }
}

.paper-item-df {
    background: #FFF9F2;
}
.overS{
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 840px;
}
.seachHeader {
    display: flex;
    justify-content: space-between;

    .input-with-select {
        width: 200px;

        &:deep .el-input-group__append button.el-button--danger {
            color: #FFF;
            background-color: #F56C6C;
            border-color: #F56C6C;
            border-top: inherit;
        }
    }
}

</style>